<div class="product-page" [ngClass]="'default-store'">
  @if (!productInfoLoaded) {
    <div class="loader__overlay">
      <div class="loader__content">
        <div class="loading-animation"></div>
      </div>
    </div>
  } @else {
    <h1 class="product__title mobile" [attr.data-test]="'title-productTitle'">{{ abstractProduct.name }}</h1>
    <app-access-control [notForViewer]="true" [description]="false">
      <ng-container ngProjectAs="[slot][nonViewerContent]">
        @if ((isMyInstalledBaseFlowEnabled$ | async) || (isPredefinedEquipmentFlowEnabled && systemDetails?.siemensEquipmentId)) {
          <app-equipment-selection
              class="col-xl-8"
              [currentCart]="currentCart"
              [systemDetails]="systemDetails"
              [isPredefinedEquipmentFlowEnabled]="isPredefinedEquipmentFlowEnabled"
              [loading]="loadingCartDataInProgress || wasRedirectedFromEquipmentPage">
          </app-equipment-selection>
        }
      </ng-container>
    </app-access-control>
    <div class="row justify-content-center">
      <div class="col-xl-7 product-image__wrapper no-padding">
        <div [appLoadingAnimation]="!productInfoLoaded">
          <div class="carousel-main row">
            <div class="col-sm-12 col-md-2 product-image__thumbnails">
              @for (small of smallUrls; track $index; let indexOfElement = $index) {
                <div
                  class="image__thumbnail"
                  (click)="setLargeUrl(indexOfElement)">
                  <img [src]="small" [alt]="productInfoLoaded ? abstractProduct.name : ''"/>
                </div>
              }
            </div>
            <div class="col-sm-12 col-md-10 product-image__main">
              <img [src]="mainPicture"
                (click)="openZoomPicture()"
                class="image__main"
                [alt]="productInfoLoaded ? abstractProduct.name : ''"
                [attr.data-test]="'img-productImage'"/>
              <app-access-control>
                <ng-container ngProjectAs="[slot][content]">
                  <app-sticker
                    [product]="abstractProduct"
                    [labels]="labels"
                    [prices]="[defaultPrice, secondPrice]">
                  </app-sticker>
                </ng-container>
              </app-access-control>
            </div>
          </div>
          @if (openZoomedPicture) {
            <div class="modal-dialog is-open"
              tabindex="-1"
              id="modal-zoom-picture"
              role="dialog"
              aria-modal="true"
              aria-labelledby="modal-confirm-decline_title"
              aria-describedby="modal-confirm-decline_desc"
              aria-hidden="true"
              data-linked="#modal-zoom-picture" (click)="openZoomPicture()">
              <div class="modal-dialog__container" role="document">
                <img [src]="mainPicture"
                  style="cursor: zoom-out;"
                  [alt]="abstractProduct.name"/>
              </div>
            </div>
          }
        </div>
      </div>
      <div class="col-xl-3">
        @if (productInfoLoaded) {
          <app-access-control [notForViewer]="true">
            <ng-container ngProjectAs="[slot][nonViewerContent]">
              @if (isWishlistsActive) {
                <app-add-to-wishlist
                  [wishlists]="wishlists"
                  [sku]="concreteSku"
                  [productName]="abstractProduct.name"
                  [productKeywords]="abstractProduct.attributes.mcm_keywords"
                  [addNewModalActive]="addNewModalActive"
                  [textNextToIcon]="true"
                  (createNew)="addToWishlist()">
                </app-add-to-wishlist>
              }
            </ng-container>
          </app-access-control>
          <h1 class="product__title desktop" [attr.data-test]="'title-productTitle'">{{ abstractProduct.name }}</h1>
          <div class="material_number"
               [attr.data-test]="'desc-productMaterialNumber'">
            {{ abstractProduct.attributes.material_number }}
          </div>
          <app-access-control [notForViewer]="true" [description]="false">
            <ng-container ngProjectAs="[slot][nonViewerContent]">
              @if (isProductTagsActive && isExchangeableTagShown()) {
                <span class="label exchangeable-item">
                  {{ 'spare-parts.exchangeable-item' | translate }}
                </span>
              }
            </ng-container>
          </app-access-control>
          <p [innerHTML]="abstractProduct.description" [attr.data-test]="'desc-productDescription'"
          class="basic-product-link"></p>
          <app-access-control>
            <ng-container ngProjectAs="[slot][content]">

              <!-- Feature isProductVariantsEnabled$ FALSE → simple price -->
              @if ((isProductVariantsEnabled$ | async) === false && productInfoLoaded && defaultPrice && (priceUtils.getPriceValue(defaultPrice) | shouldDisplayPrice)) {
                <div class="price_details price_details--simple">
                  <h4 id="product__description__price" [attr.data-test]="'title-productPrice'">
                    {{ priceUtils.getPriceValue(defaultPrice) | currency: priceUtils.getCurrencyCode(defaultPrice) }}
                    @if (secondPrice) {
                      <small class="product__description__price-alternative"
                        [attr.data-test]="'desc-productPriceAlternative'">
                        {{ priceUtils.getPriceValue(secondPrice) | currency: priceUtils.getCurrencyCode(secondPrice) }}
                      </small>
                    }
                  </h4>
                  @if (!isExcludeTaxActive()) {
                    <span class="ex-gst-container" [attr.data-test]="'desc-taxDisclaimer'">
                      ({{ 'app-product-page.ex_gst' | translate }})
                    </span>
                  }
                </div>
              }

              <!-- Feature isProductVariantsEnabled$ TRUE → price variants -->
              @if ((isProductVariantsEnabled$ | async) && productInfoLoaded && (isPriceBlockDisplayed(priceVariant.WITHOUT_REPLACEMENT) || isPriceBlockDisplayed(priceVariant.WITH_REPLACEMENT)) && ((priceUtils.getPriceValue(yourPriceWithoutReplacement) | shouldDisplayPrice) || (priceUtils.getPriceValue(yourPriceWithReplacement) | shouldDisplayPrice))) {
                <div class="price_details price_details--variants">

                  <!-- Without replacement block -->
                  @if (isPriceBlockDisplayed(priceVariant.WITHOUT_REPLACEMENT)) {
                    <div class="price_block" [ngClass]="{'price_block--single': isSinglePriceBlock()}">
                      <div class="price_block__header">
                        @if (!isSinglePriceBlock()) {
                          <input type="radio"
                                 class="radio"
                                 id="price-without-replacement"
                                 name="priceSelection"
                                 [value]="priceVariant.WITHOUT_REPLACEMENT"
                                 [(ngModel)]="selectedPriceType"/>
                          <label class="price_block__title"
                                 for="price-without-replacement">{{ 'app-product-page.without-replacement-label' | translate }}</label>
                        }
                        @if (isSinglePriceBlock()) {
                          <span
                              class="price_block__title price_block__title--single">{{ 'app-product-page.without-replacement-label' | translate }}</span>
                        }
                      </div>
                      <div class="price_block__rows">

                        <!-- List price -->
                        @if (listPriceWithoutReplacement) {
                          <div class="price_row price_row--list-price">
                            <span class="price_row__label">{{ 'app-product-page.list-price-label' | translate }}</span>
                            <span class="price_row__value-group">
                          <span class="price_row__value price_row__value--strikethrough">
                            {{ priceUtils.getPriceValue(listPriceWithoutReplacement) | currency: priceUtils.getCurrencyCode(listPriceWithoutReplacement) }}
                          </span>
                        </span>
                          </div>
                        }

                        <!-- Your price -->
                        @if (yourPriceWithoutReplacement) {
                          <div class="price_row price_row--your-price">
                            <span class="price_row__label">{{ 'app-product-page.your-price-label' | translate }}</span>
                            <span class="price_row__value-group">
                          <span class="price_row__value">
                            {{ priceUtils.getPriceValue(yourPriceWithoutReplacement) | currency: priceUtils.getCurrencyCode(yourPriceWithoutReplacement) }}
                          </span>
                        </span>
                          </div>
                        }

                        <!-- Housing fee -->
                        @if (housingFee) {
                          <div class="price_row price_row--housing-fee">
                        <span class="price_row__label-group">
                          <span class="price_row__label">{{ 'app-product-page.housing-fee-label' | translate }}</span>
                          <app-tooltip
                              link="icon"
                              text="{{'app-product-page.housing-fee-tooltip' | translate}}"
                              [attr.data-test]="'link-housing-fee-tooltip'">
                          </app-tooltip>
                        </span>
                            <span class="price_row__value-group">
                          <span class="price_row__value">
                            {{ housingFee | currency: priceUtils.getCurrencyCode(defaultPrice) : 'symbol-narrow' : 0 }}
                          </span>
                        </span>
                          </div>
                        }
                      </div>
                    </div>
                  }

                  <!-- With replacement block -->
                  @if (isPriceBlockDisplayed(priceVariant.WITH_REPLACEMENT)) {
                    <div class="price_block" [ngClass]="{'price_block--single': isSinglePriceBlock()}">
                      <div class="price_block__header">
                        @if (!isSinglePriceBlock()) {
                          <input type="radio"
                                 class="radio"
                                 id="price-with-replacement"
                                 name="priceSelection"
                                 [value]="priceVariant.WITH_REPLACEMENT"
                                 [(ngModel)]="selectedPriceType"/>
                          <label class="price_block__title"
                                 for="price-with-replacement">{{ 'app-product-page.with-replacement-label' | translate }}</label>
                        }
                        @if (isSinglePriceBlock()) {
                          <span
                              class="price_block__title price_block__title--single">{{ 'app-product-page.with-replacement-label' | translate }}</span>
                        }
                        <app-tooltip
                            link="icon"
                            text="{{'app-product-page.with-replacement-tooltip' | translate}}"
                            [attr.data-test]="'link-price-with-replacement-info'">
                        </app-tooltip>
                      </div>
                      <div class="price_block__rows">

                        <!-- List price -->
                        @if (listPriceWithReplacement) {
                          <div class="price_row price_row--list-price">
                            <span class="price_row__label">{{ 'app-product-page.list-price-label' | translate }}</span>
                            <span class="price_row__value-group">
                              <span class="price_row__value price_row__value--strikethrough">
                                {{ priceUtils.getPriceValue(listPriceWithReplacement) | currency: priceUtils.getCurrencyCode(listPriceWithReplacement) }}
                              </span>
                            </span>
                          </div>
                        }

                        <!-- Your price -->
                        @if (yourPriceWithReplacement) {
                          <div class="price_row price_row--your-price">
                            <span class="price_row__label">{{ 'app-product-page.your-price-label' | translate }}</span>
                            <span class="price_row__value-group">
                              <span class="price_row__value">
                                {{ priceUtils.getPriceValue(yourPriceWithReplacement) | currency: priceUtils.getCurrencyCode(yourPriceWithReplacement) }}
                              </span>
                            </span>
                          </div>
                        }
                      </div>
                    </div>
                  }
                </div>
              }
              <app-access-control [notForViewer]="true">
                <ng-container ngProjectAs="[slot][nonViewerContent]">
                  <ng-container>
                    <form class="button-container" (submit)="addProductToCart()">
                      <label id="label__quantity">
                        <input [attr.data-test]="'productQuantity'"
                          name="productQuantity"
                          type="number"
                          class="spinbox-quantity"
                          min="1"
                          step="1"
                          [(ngModel)]="productQuantity"
                          required
                          [disabled]="isAddToCartInProgress$ | async"
                          (change)="changeProductQuantity(productQuantity)"/>
                      </label>
                      @if (isAddToCartInProgress$ | async) {
                        <div class="loader__content">
                          <div class="loading-animation"></div>
                        </div>
                      } @else {
                        <button class="button button--primary icon-basket button--cart icon__mobile"
                          [disabled]="!isQuantityValid || loadingCartDataInProgress"
                          [attr.data-test]="'button-addToCart'">
                          {{ 'app-product-page.add-to-cart' | translate }}
                        </button>
                      }
                      @if (!isQuantityValid) {
                        <small class="textfield__hint">{{ 'app-product-page.enter-quantity' | translate }}</small>
                      }
                    </form>
                  </ng-container>
                </ng-container>
              </app-access-control>
              @if (priceUtils.getPriceValue(defaultPrice) | shouldDisplayPrice) {
                <div>
                  @let isVariantsEnabled = isProductVariantsEnabled$ | async;
                  <p class="product-availability"
                     [ngClass]="{'product-availability--variants': isVariantsEnabled}">
                    @if (isVariantsEnabled && !isExcludeTaxActive()) {
                      <span class="product-availability--variants">
                        {{ 'app-product-page.prices-excluding-vat-disclaimer' | translate }}
                      </span>
                    }
                    @if (showPriceDisclaimer) {
                      {{ 'shop-cart.excludes-vat' | translate }}<br/>
                      {{ 'shop-cart.pricing-validation' | translate }}
                    } @else {
                      @let showDeliveryAvailability = isDeliveryAvailabilityEnabled && abstractProduct.attributes.delivery_availability;
                      @let showEstimatedDelivery = isEstimatedDeliveryEnabled && abstractProduct.attributes.delivery_time;
                      @if (showDeliveryAvailability) {
                        <span [attr.data-test]="'desc-productAvailability'">
                          {{ abstractProduct.attributes.delivery_availability }}
                        </span>
                      }
                      @if (showDeliveryAvailability && showEstimatedDelivery) {
                        <br/>
                      }
                      @if (showEstimatedDelivery) {
                        <span [attr.data-test]="'desc-productDeliveryTime'">
                          {{ 'shop-cart.estimatedArrivalLabel' | translate }}{{ abstractProduct.attributes.delivery_time }}
                        </span>
                      }
                    }
                  </p>
                </div>
              }
              </ng-container>
            </app-access-control>
          }
        </div>
        <div class="col-xl-10 product-details-wrapper">
          <div class="product-details">
            @if (productInfoLoaded) {
              <div class="accordion" role="presentation">
                @if (displayProductDetail(productDetailsEnum.PRODUCT_ORIGIN)) {
                  <app-accordion
                    (panelOpened)="tracking(productDetailsEnum.PRODUCT_ORIGIN.toString())" class="basic-product-link">
                    <ng-container ngProjectAs="[slot][header]">
                      <h2 id="panel-product-origin-button"
                        class="accordion__title icon-arrow-down" aria-controls="panel1"
                        aria-expanded="false"
                        [attr.data-test]="'panel-productOrigin'">
                        {{ 'app-product-page.product-origin' | translate }}
                      </h2>
                    </ng-container>
                    <ng-container ngProjectAs="[slot][panel]">
                      <div class="container accordion__content">
                        @if (abstractProduct?.attributeNames) {
                          <div class="row accordion__panel__text">
                            <p class="accordion__panel__text__category col-4 col-lg-2">{{ abstractProduct.attributeNames.mcm_manufacturer }}</p>
                            <p class="accordion__panel__text__category col-8 col-lg-10"
                            [innerHTML]="abstractProduct.attributes.mcm_manufacturer"></p>
                            @if (!isInStore) {
                              <p class="accordion__panel__text__category col-4 col-lg-2">{{ abstractProduct.attributeNames.mcm_packer }}</p>
                              <p class="accordion__panel__text__category col-8 col-lg-10"
                              [innerHTML]="abstractProduct.attributes.mcm_packer"></p>
                            }
                            <p class="accordion__panel__text__category col-4 col-lg-2">{{ abstractProduct.attributeNames.mcm_importer }}</p>
                            <p class="accordion__panel__text__category col-8 col-lg-10"
                            [innerHTML]="abstractProduct.attributes.mcm_importer"></p>
                            <p class="accordion__panel__text__category col-4 col-lg-2">{{ abstractProduct.attributeNames.sap_country_of_origin }}</p>
                            <p class="accordion__panel__text__category col-8 col-lg-10"
                            [innerHTML]="abstractProduct.attributes.sap_country_of_origin"></p>
                          </div>
                        }
                      </div>
                    </ng-container>
                  </app-accordion>
                }
                @if (displayProductDetail(productDetailsEnum.OVERVIEW)) {
                  <app-accordion
                    (panelOpened)="tracking(productDetailsEnum.OVERVIEW.toString())"
                    class="basic-product-link">
                    <ng-container ngProjectAs="[slot][header]">
                      <h2 id="panel-overview-button"
                        class="accordion__title icon-arrow-down" aria-controls="panel1"
                        aria-expanded="false"
                        [attr.data-test]="'panel-overview'">
                        {{ 'app-product-page.overview' | translate }}
                      </h2>
                    </ng-container>
                    <ng-container ngProjectAs="[slot][panel]">
                      <div class="container accordion__content">
                        <p class="accordion__panel__text" [attr.data-test]="'desc-overview'"
                        [innerHTML]="abstractProduct.description"></p>
                      </div>
                    </ng-container>
                  </app-accordion>
                }
                @if (displayProductDetail(productDetailsEnum.DIMENSIONS)) {
                  <app-accordion
                    (panelOpened)="tracking(productDetailsEnum.DIMENSIONS.toString())" class="basic-product-link">
                    <ng-container ngProjectAs="[slot][header]">
                      <h2 (click)="tracking(productDetailsEnum.DIMENSIONS.toString())" id="panel-dimensions-button"
                        class="accordion__title icon-arrow-down" aria-controls="panel1"
                        aria-expanded="false"
                        [attr.data-test]="'panel-dimensions'">
                        {{ 'app-product-page.dimensions' | translate }}
                      </h2>
                    </ng-container>
                    <ng-container ngProjectAs="[slot][panel]">
                      <div class="container accordion__content">
                        @if (abstractProduct?.attributeNames) {
                          <div class="row accordion__panel__text">
                            <p class="accordion__panel__text__category col-4 col-lg-2" [attr.data-test]="'label_length'">
                              {{ abstractProduct.attributeNames.sap_length }}
                            </p>
                            <div class="col-8 col-lg-10">
                              <p class="accordion__panel__text__category spec accordion__panel__dimension"
                                [attr.data-test]="'desc-length'">
                                @if (abstractProduct.attributes?.sap_length) {
                                  {{ abstractProduct.attributes.sap_length }} cm
                                } @else {
                                  -
                                }
                              </p>
                            </div>
                            <p class="accordion__panel__text__category col-4 col-lg-2" [attr.data-test]="'label-height'">
                              {{ abstractProduct.attributeNames.sap_height }}
                            </p>
                            <div class="col-8 col-lg-10">
                              <p class="accordion__panel__text__category spec accordion__panel__dimension"
                                [attr.data-test]="'desc-height'">
                                @if (abstractProduct.attributes?.sap_height) {
                                  {{ abstractProduct.attributes.sap_height }} cm
                                } @else {
                                  -
                                }
                              </p>
                            </div>
                            <p class="accordion__panel__text__category col-4 col-lg-2" [attr.data-test]="'label-width'">
                              {{ abstractProduct.attributeNames.sap_width }}
                            </p>
                            <div class="col-8 col-lg-10">
                              <p class="accordion__panel__text__category spec accordion__panel__dimension"
                                [attr.data-test]="'desc-width'">
                                @if (abstractProduct.attributes?.sap_width) {
                                  {{ abstractProduct.attributes.sap_width }} cm
                                } @else {
                                  -
                                }
                              </p>
                            </div>
                            <p class="accordion__panel__text__category col-4 col-lg-2" [attr.data-test]="'label-weight'">
                              {{ abstractProduct.attributeNames.sap_gross_weight }}
                            </p>
                            <div class="col-8 col-lg-10">
                              <p class="accordion__panel__text__category spec accordion__panel__dimension"
                                [attr.data-test]="'desc-weight'">
                                @if (abstractProduct.attributes?.sap_gross_weight) {
                                  {{ abstractProduct.attributes.sap_gross_weight }} kg
                                } @else {
                                  -
                                }
                              </p>
                            </div>
                          </div>
                        }
                      </div>
                    </ng-container>
                  </app-accordion>
                }
                @if (displayProductDetail(productDetailsEnum.DETAILS)) {
                  <app-accordion
                    (panelOpened)="tracking(productDetailsEnum.DETAILS.toString())" class="basic-product-link">
                    <ng-container ngProjectAs="[slot][header]">
                      <h2 id="panel-details-button"
                        class="accordion__title icon-arrow-down"
                        aria-controls="panel1"
                        aria-expanded="false"
                        [attr.data-test]="'panel-details'">
                        {{ 'app-product-page.details' | translate }}
                      </h2>
                    </ng-container>
                    <ng-container ngProjectAs="[slot][panel]">
                      <div class="container accordion__content">
                        @if (abstractProduct?.attributeNames) {
                          <div class="row">
                            <div class="accordion__panel__text col-4 col-xl-2">
                              <p class="accordion__panel__text__category" [attr.data-test]="'label-materialNumber'">
                                {{ abstractProduct.attributeNames.material_number }}
                              </p>
                              <p class="accordion__panel__text__category" [attr.data-test]="'label-materialType'">
                                {{ abstractProduct.attributeNames.Material_Type }}
                              </p>
                            </div>
                            <div class="accordion__panel__text col-8 col-xl-10">
                              <p class="accordion__panel__text__category spec" [attr.data-test]="'desc-materialNumber'">
                                {{ abstractProduct.attributes.material_number }}
                              </p>
                              <p class="accordion__panel__text__category spec" [attr.data-test]="'desc-materialType'">
                                {{ abstractProduct.attributes.Material_Type }}
                              </p>
                            </div>
                          </div>
                        }
                      </div>
                    </ng-container>
                  </app-accordion>
                }
                @if (displayProductDetail(productDetailsEnum.SUITABLE_FOR)
                  && installBaseProducts
                  && installBaseProducts.length > 0) {
                  <app-accordion
                    (panelOpened)="tracking(productDetailsEnum.SUITABLE_FOR.toString())" class="basic-product-link">
                    <ng-container ngProjectAs="[slot][header]">
                      <h2 id="panel-suitable-button"
                        class="accordion__title icon-arrow-down" aria-controls="panel1"
                        aria-expanded="false"
                        [attr.data-test]="'panel-suitableFor'">
                        {{ 'app-product-page.suitable-for' | translate }}
                      </h2>
                    </ng-container>
                    <ng-container ngProjectAs="[slot][panel]">
                      <div class="container accordion__content">
                        <div class="accordion__panel__text install-base-pointer">
                          @for (installedBase of installBaseProducts; track installedBase) {
                            <p>
                              <a [routerLink]="['/installed-base']"
                                [queryParams]="{'rel-product-sysivk': installedBase.attributes.materialNumber}"
                                (click)="trackInstalledBase(installedBase)"
                                [attr.data-test]="'desc-' + installedBase.attributes.nameEnUs">
                                {{ installedBase.attributes.nameEnUs }}
                              </a>
                            </p>
                          }
                        </div>
                      </div>
                    </ng-container>
                  </app-accordion>
                }
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>
